import React from 'react';
import { useHistory } from 'react-router-dom';
import { Loader } from '../../../../components';
import * as s from './styled-energia';

// Card "Maquina" do header. Removida a imagem ConjuntoBomba (so aparecia
// > 1285px e gerava layout desbalanceado/box vazio) e o useWidth. Agora
// e um card compacto: badge + label/nome + botao "Ver mais" que abre a
// tela operacional carregando o contexto da thing.
const EnergiaGerada = ({ thing, aplicacao, variables, values, loading }) => {
  const history = useHistory();

  return (
    <s.Container>
      {!loading ? (
        <>
          <s.Badge>
            {/* lucide:monitor — representa o supervisorio da maquina */}
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.7"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <rect x="2" y="3" width="20" height="14" rx="2" />
              <path d="M8 21h8M12 17v4" />
            </svg>
          </s.Badge>
          <s.Info>
            <s.Label>Máquina</s.Label>
            <s.Name title={thing.thing}>{thing.thing}</s.Name>
          </s.Info>
          <s.MoreButton
            onClick={() => {
              history.push('/dashboard/customer/operational', {
                thing,
                aplicacao,
                variables,
                values,
              });
            }}
            type="button"
          >
            Ver mais
            {/* lucide:chevron-right */}
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M9 18l6-6-6-6" />
            </svg>
          </s.MoreButton>
        </>
      ) : (
        <Loader />
      )}
    </s.Container>
  );
};

export default EnergiaGerada;
